import { get, map, find, toLower, isEmpty, isNil } from 'lodash';
import { Helpers } from '@utils/helpers';

export class CoverageAttribute {
  public sumAssured: number;
  public planPremiumMode: string;
  //public nationalityCode: string;
  public residencyCodeLifeAssured?: string;
  public assuredNationalityCode?: string;
  public isLifeAssuredPR?: string;
  public residencyCodeAssured?: string;
  public sourceOfFunds?: string;
  public currency?: string;
  public isAssuredPR?: string;

  /**Optionals */
  public code?: string;
  public riderType?: string;
  public policyTerm?: number | string;
  public premiumTerm?: number | string;
  public maxProjTerm?: number;
  public sumAssuredMin?: number;
  public sumAssuredMax?: number;
  public modalPremiumMin?: number;
  public modalPremiumMax?: number;
  public paymentFreq?: number;
  public expiryAge?: number;
  public componentCode?: string;
  public mortalityClass?: string;
  public residencyCode?: string;
  public assuredResidencyCode?: string;
  public annualisedPremium?: number;
  public trueAnnualisedPremium?: number;
  public annualPremium?: number;
  public halfYearlyPremium?: number;
  public quarterlyPremium?: number;
  public monthlyPremium?: number;
  public modalPremium?: number;
  public insurancePremium?: number;
  public annualizedPremium?: number;
  public promoCodeSummary?: string;
  public discountEligible?: boolean;
  public firstYrDiscountEligible?: boolean;
  public discountedPremium?: any;
  public promoCode?: string;
  public productCode?: string;
  public monthlyBenefit?: number;
  public benefitPayoutDuration?: string;
  public premiumTermYears?: number;
  public escBenefit?: string;
  public campaign_code?: string;

  constructor(initial: any) {
    this.sumAssured = get(initial, 'sumAssured', '-');
    this.planPremiumMode = get(initial, 'planPremiumMode', 'AP');
    this.currency = get(initial, 'currency', 'SGD');
    this.monthlyBenefit = get(initial, 'monthlyBenefit', 0);
    this.premiumTerm = get(initial, 'premiumTerm', 'lifetime');
    this.benefitPayoutDuration = get(initial, 'benefitPayoutDuration', 'lifetime');
    this.escBenefit = get(initial, 'escBenefit', '2');
    this.campaign_code = get(initial, "campaignCode", "");
    // this.sourceOfFunds = get(initial, 'sourceOfFunds', 'Cash');
    Object.assign(this, initial);
  }
}

interface ICoveragesAdlPayload {
  id: string;
  type: string;
  attributes: Object;
}

export class CoveragesAdlPayload {
  public id: string;
  public type: string;
  public attributes: Object;

  constructor(initialData: ICoveragesAdlPayload) {
    this.id = get(initialData, "id", "");
    this.type = get(initialData, "type", "");
    this.attributes = get(initialData, "attributes", "");
  }
}

export class Coverages {
  public id: string;
  public type: string;
  public name?: string;
  public productClass?: string;
  public class?: string;
  public premiumType?: string;
  public mode?: string;
  public productCode?: string;
  public code?: string;
  public riderType?: string;
  public addType?: string;
  public attributes?: CoverageAttribute;
  constructor(initial: any) {
    this.id = get(initial, 'id', 'myCareEnhanced');
    this.type = get(initial, 'type', 'P');
    Object.assign(this, initial);
  }
}
export class LifeProfile {
  public name: string;
  public gender: string;
  public smoker: string;
  public dob: string;
  public age: number;
  public occupationName: string;
  public relationshipName: string;
  public relationshipId: string;
  public type: string;
  public occupationCode?: string;
  public riskClass?: string;
  constructor(initial: any) {
    this.name = get(initial, 'name', '');
    this.gender = get(initial, 'gender', '');
    this.smoker = get(initial, 'smoker', '');
    this.dob = get(initial, 'dob', '');
    this.age = get(initial, 'age', 0);
    this.occupationName = get(initial, 'occupationName', '');
    this.relationshipName = '';
    this.relationshipId = '';
    this.type = 'life-assured';
    if (initial.occupationCode) {
      this.occupationCode = get(initial, 'occupationCode', '');
    }
    if (initial.riskClass) {
      this.riskClass = get(initial, 'riskClass', '');
    }
  }
}

  export class Campaigns {
  public code: string;
  public nric: string;
  constructor(initial: any) {
    this.code = get(initial, 'code', '');
    this.nric = get(initial, 'nric', '');    
  }
}

export class SQSPocketRequest {
  public proposalType: string;
  public lifeprofiles: LifeProfile[];
  public isBIStacking: boolean;
  public coverages: (Coverages | CoveragesAdlPayload)[];
  public document: string[];
  public backdate: string;
  public psqsversion: string;
  public deviceos: string;
  public firmClntnum: string;
  public sourceOfBusiness: string;
  public loginId: string;
  public mltc: boolean;
  public transactionId: string;
  public encryptedPromoCode: boolean;
  public agentCode: string;
  public campaigns?: Campaigns[]

  constructor(initial: any) {
    this.proposalType = get(initial, 'proposalType', 'LA');
    this.lifeprofiles = get(initial, 'lifeprofiles', []);
    this.coverages = get(initial, 'coverages', []);
    this.isBIStacking = get(initial, 'isBIStacking', false);
    this.document = get(initial, 'document', []);
    this.backdate = get(initial, 'backdate', '');
    this.psqsversion = get(initial, 'psqsversion', '1.15.11.14');
    this.deviceos = get(initial, 'deviceos', '');
    this.firmClntnum = get(initial, 'firmClntnum', '');
    this.sourceOfBusiness = get(initial, 'sourceOfBusiness', '');
    this.loginId = get(initial, 'loginId', 'QnB');
    this.transactionId = get(initial, 'transaction_id', '');
    this.mltc = true;
    this.encryptedPromoCode = get(initial, 'encryptedPromoCode', false);
    this.agentCode = get(initial, 'agentCode', '');
    this.campaigns = get(initial, 'campaigns', [])
  }
}

export class SQSPocketResponse {
  loginId: string;
  firmClntnum: string;
  sourceOfBusiness: string;
  proposalType: string;
  isBIStacking: boolean;
  tables: any;
  errors: any;
  sqsVersion: string;
  infos: any;
  lifeProfiles: LifeProfile[];
  coverages: Coverages[];
  discountEligible?: boolean;
  perpetualDiscountEligible?: boolean;
  firstYearDiscountEligible?: boolean;
  additionalChecks?: boolean;

  monthlyBenefit?: number | string;
  totalPerpetualDiscount?: number;
  totalFirstYearDiscount?: number;
  totalOriginalPremiumAmt?: number | string;
  totalAftDisOriginalPremiumAmt?: number;
  totalAnnualizedPremium?: number;

  totalOriginalPremium?: any;
  totalAftDisOriginalPremium?: any;

  isCIRider?: boolean;
  isPARider?: boolean;
  
  age?: number;
  planName?: string;
  planStructure?: string;
  planStructureDesc?: string;
  premiumTerm?: string;
  premiumTermOption?: string;
  premiumTermDesc?: string;
  cpfMedisaveAmount?: number;
  cashPayment?: number;
  discountedTotalFirstYrPremium?: number;
  totalPremium?:number;
  nonDiscountedTotalPremium?:number;
  discountedValue?: number;
  
  public name: string;

  constructor(initial: any, age: any = 0) {
    this.age = age;
    this.loginId = get(initial, 'loginId', '');
    this.firmClntnum = get(initial, 'firmClntnum', '');
    this.sourceOfBusiness = get(initial, 'sourceOfBusiness', '');
    this.proposalType = get(initial, 'proposalType', '');
    this.isBIStacking = get(initial, 'isBIStacking', false);
    this.sqsVersion = get(initial, 'sqsVersion', false);
    this.tables = get(initial, 'tables', []);
    this.errors = get(initial, 'errors', []);
    this.infos = get(initial, 'infos', []);

    this.planStructure = get(initial, 'planStructure', '');
    this.planStructureDesc = get(initial, 'planStructureDesc', '');
    this.premiumTerm = get(initial, 'premiumTerm', '');
    this.premiumTermOption = get(initial, 'premiumTermOption', '');
    this.premiumTermDesc = get(initial, 'premiumTermDesc', '');
    this.cpfMedisaveAmount = get(initial, 'cpfMedisaveAmount', '');
    this.cashPayment = get(initial,"coverages[0].attributes.cashPaymentCalculated")

    this.totalOriginalPremium = get(initial, 'totalOriginalPremium', '-');
    this.totalAftDisOriginalPremium = get(initial, 'totalAfterDiscountPremium', '-');
    this.totalAnnualizedPremium = get(initial, 'totalAnnualizedPremium', '-');

    const profiles = get(initial, 'lifeProfiles', []);
    this.lifeProfiles = map(profiles, p => new LifeProfile(p));

    const coverages = get(initial, 'coverages', []);
    this.coverages = map(coverages, co => {
      const atts = get(co, 'attributes', {});
      const attributes = new CoverageAttribute(atts);
      return new Coverages({ ...co, attributes });
    });
    const myPlan: Coverages | undefined = find(coverages, { type: 'P' });

    //New Values added for MLTC_R4
    this.totalPremium = get(myPlan, "attributes.totalPremium", 0);
    this.nonDiscountedTotalPremium = get(
      myPlan,
      "attributes.nonDiscountedTotalPremium",
      0
    );
    this.discountedTotalFirstYrPremium = get(
      myPlan,
      "attributes.discountedTotalFirstYrPremium",
      0
    );
    this.discountedValue = get(myPlan, "attributes.discountedValue", 0);

    this.planName = get(myPlan, 'name', '-');
    this.discountEligible = get(myPlan, 'attributes.discountEligible', false) && Boolean(get(myPlan, 'attributes.discountedPremium', false));
    this.perpetualDiscountEligible = this.discountEligible && (get(myPlan, 'attributes.discountedPremium.staffDiscount', 0) > 0);
    this.firstYearDiscountEligible = this.discountEligible && get(myPlan, 'attributes.firstYrDiscountEligible', false) && Boolean(get(myPlan, 'attributes.discountedPremium', false)) && (get(myPlan, 'attributes.discountedPremium.firstYrDiscAmnt', 0) > 0);

    this.totalPerpetualDiscount = get(myPlan, 'attributes.discountedPremium.staffDiscount', '-');
    this.totalFirstYearDiscount = Number(get(myPlan, 'attributes.discountedPremium.firstYrDisc', '-'));

    const firsYearDiscountType = get(myPlan, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(myPlan, 'attributes.discountedPremium.firstYrDisc', 0);
    }

    this.monthlyBenefit = get(myPlan, 'attributes.monthlyBenefit', '-');
    this.totalOriginalPremiumAmt = get(myPlan, 'attributes.modalPremium', '-');
    this.totalAftDisOriginalPremiumAmt = get(myPlan,
      this.discountEligible ?
        (this.firstYearDiscountEligible ? 'attributes.discountedPremium.firstYrModalPremium' :
          'attributes.discountedPremium.modalPremium') :
      'attributes.modalPremium', '-');

    this.additionalChecks = get(myPlan, 'attributes.discountedPremium.additionalChecks', false) === 'Y';
    this.name = get(myPlan, 'name', '-');
  }

  public get sioQuote() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    const planPremiumMode = get(simplePlan, 'attributes.planPremiumMode', '');
    const premiumFreq = Helpers.getPremiumTermByCode(planPremiumMode);
    if (simplePlan) {
      const simplePlanDetails = this.getPlanDetails(simplePlan);
      listing.push(
        {
          name: 'Basic plan',
          details: [
            { text: 'Basic plan', value: get(simplePlanDetails, 'name', '-') },
            { text: 'Sum assured', value: get(simplePlanDetails, 'sumAssured', '-') },
            { text: 'Premium payment term', value: `Yearly renewable` },
            { text: 'Premium amount', value: get(simplePlanDetails, 'discPremiumAmount', '-') },
          ]
        }

      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push({
        name: 'Add-ons',
        details: [
          { text: 'Rider', value: get(ciPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
          { text: 'Premium payment term', value: `Yearly renewable` },
          { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    if (personalAccidentPlan) {
      const paPlanDetails = this.getPlanDetails(personalAccidentPlan);
      listing.push({
        details: [
          { text: 'Rider', value: get(paPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: Helpers.toCurrency(get(paPlanDetails, 'sumAssured', '-')) },
          { text: 'Premium payment term', value: `Yearly renewable` },
          { text: 'Premium amount', value: get(paPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    const promotions = [
      this.perpetualDiscountEligible && 'Perpetual discount',
      this.firstYearDiscountEligible && 'First year discount',
    ]

    listing.push(
      {
        name: 'Other details',
        details: [
          { text: 'Premium payment frequency', value: premiumFreq },
          {
            text: 'Promo code',
            value: get(simplePlan, 'attributes.promoCode', '-'),
            type: 'promotion',
            promotions: promotions.filter(o => !isNil(o) && !isEmpty(o)),
          },
        ]
      }
    )

    return listing;

  }

  public get dpiQuote() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    const premiumFrequency = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));
    if (directTermPlan) {
      const directPlanDetails = this.getPlanDetails(directTermPlan);
      listing.push(
        {
          name: 'Basic plan',
          details: [
            { text: 'Basic plan', value: get(directPlanDetails, 'name', '-') },
            { text: 'Sum assured', value: get(directPlanDetails, 'sumAssured', '-') },
            { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
            { text: 'Premium amount', value: get(directPlanDetails, 'discPremiumAmount', '-') },
          ]
        }

      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push({
        name: 'Add-on(s)',
        details: [
          { text: 'Rider', value: get(ciPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
          { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
          { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    listing.push(
      {
        name: 'Other details',
        details: [
          { text: 'Premium payment frequency', value: premiumFrequency },
        ]
      }
    )

    return listing;

  }

  public get mltcPlanDetails() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const coverage: Coverages | undefined = find(coverages, { type: 'P' });
    const totalPremium = Helpers.toCurrency(this.totalAftDisOriginalPremiumAmt || 0);
    const monthlyBenefit = Helpers.toCurrency(Number(this.monthlyBenefit) || 0);
    const annualPremium = Helpers.toCurrency(Number(this.totalOriginalPremiumAmt)) || 0;
    const hasDiscount = this.firstYearDiscountEligible || this.perpetualDiscountEligible;
    const firsYearDiscountType = get(coverage, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(coverage, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    console.log('QnB ➤ ', { coverage });

    const age = this.age || 0;
    const escBenefit = get(coverage, 'attributes.escBenefit', '-');
    const policyTerm = get(coverage, 'attributes.policyTerm', '-');
    const premiumTerm = get(coverage, 'attributes.premiumTerm', '-');
    const policyDesc = premiumTerm === 'limited' ? `For ${age >= 49 ? 20 : 69 - age} years, until I'm ${age >= 49 ? age + 20 : 69} Age Next Birthday` : `For ${99 - age} years, until I'm 99 Age Next Birthday`;
    const escBenefitDesc = escBenefit === 'level' ? `I prefer fixed structure - same payout, same premium every year` : escBenefit === '2' ? `I prefer increasing payout and premium at 2% per year` : `I prefer increasing payout and premium at 3% per year`;
      

    listing.push(
      { text: 'Plan', value: get(coverage, 'name', '-'), fontWeight: 'bold' },
      { text: 'Monthly benefit payout', value: monthlyBenefit },
      { text: 'Plan structure', value: escBenefitDesc },
      { text: 'Policy term', value: 'Lifetime' },
      { text: 'Premium term', value: policyDesc },
    );
    if (hasDiscount) {
      listing.push(
        { text: 'Total annual premium before discount', value: annualPremium },
        { text: 'Total annual premium after discount', value: totalPremium },
        this.perpetualDiscountEligible && { text: 'Perpetual Discount', value: `${this.totalPerpetualDiscount}%` },
        this.firstYearDiscountEligible && { text: 'First year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType) }
      )
    } else {
      listing.push(
        { text: 'Total annual premium', value: totalPremium },
      )
    }

    listing.push(
      { text: 'Paid via CPF MediSave', value: Number(this.totalAftDisOriginalPremiumAmt) > 600 ? Helpers.toCurrency(600) : Helpers.toCurrency(Number(this.totalAftDisOriginalPremiumAmt)) },
      { text: 'Remaining payable premium', value: Number(this.totalAftDisOriginalPremiumAmt) > 600 ? Helpers.toCurrency(Number(this.totalAftDisOriginalPremiumAmt)-600) : Helpers.toCurrency(0) },
    );
    
    return listing;
  }

  public get mltcSummary() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const coverage: Coverages | undefined = find(coverages, { type: 'P' });
    const totalPremium = Helpers.toCurrency(this.discountedTotalFirstYrPremium || 0);
    const monthlyBenefit = Helpers.toCurrency(Number(this.monthlyBenefit) || 0);
    const firsYearDiscountType = get(coverage, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(coverage, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    console.log('QnB ➤ ', { coverage });

    const age = this.age || 0;
    const escBenefit = get(coverage, 'attributes.escBenefit', '-');
    const premiumTerm = get(coverage, 'attributes.premiumTerm', '-');
    const policyDesc = premiumTerm === 'limited' ? `For ${age >= 49 ? 20 : 69 - age} years, until I'm ${age >= 49 ? age + 20 : 69} Age Next Birthday` : `For ${99 - age} years, until I'm 99 Age Next Birthday`;
    const escBenefitDesc = escBenefit === 'level' ? `I prefer fixed structure - same payout, same premium every year` : escBenefit === '2' ? `I prefer increasing payout and premium at 2% per year` : `I prefer increasing payout and premium at 3% per year`;
      

    listing.push(
      { text: 'Plan', value: get(coverage, 'name', '-') },
      { text: 'Monthly benefit payout', value: monthlyBenefit },
      { text: 'Plan structure', value: escBenefitDesc },
      { text: 'Policy term', value: 'Lifetime' },
      { text: 'Premium term', value: policyDesc },
      { text: 'Premium amount', value: totalPremium },
    );
    
    return listing;
  }

  public get mltcPremium() {
    const age = this.age || 0;
    const coverages = [...this.coverages];
    const coverage: Coverages | undefined = find(coverages, { type: 'P' });
    const totalPremium = Helpers.toCurrency(this.totalAftDisOriginalPremiumAmt || 0);
    const monthlyBenefit = Helpers.toCurrency(Number(this.monthlyBenefit) || 0);
    const annualPremium = this.totalOriginalPremiumAmt || 0;
    const premiumTerm = get(coverage, 'attributes.premiumTerm', '-');

    const hasDiscount = this.firstYearDiscountEligible || this.perpetualDiscountEligible;
    const firsYearDiscountType = get(coverage, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(coverage, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    const promotions: any[] = [];
    if (hasDiscount) {
      promotions.push(
        this.perpetualDiscountEligible && { text: 'Perpetual Discount', value: `${this.totalPerpetualDiscount}%` },
        this.firstYearDiscountEligible && { text: 'First year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType) },
      )
    }

    console.log({monthlyBenefit});
    return {
      premiumYears: (premiumTerm === 'limited') ? age >= 49 ? 20 : 69 - age : 99 - age,
      cashPayment: this.cashPayment,
      totalAnnualizedPremium: this.totalAftDisOriginalPremiumAmt,
      nonDiscountedTotalPremium: this.nonDiscountedTotalPremium,
      discountedTotalFirstYrPremium: this.discountedTotalFirstYrPremium,
      discountedValue: this.discountedValue,
      totalPremium: { text: `total annual premium`, value: this.totalPremium || 0 },
      monthlyBenefit: { text: `Monthly benefit payout`, value: monthlyBenefit },
      details: [
        { text: `${hasDiscount ? 'Total annual premium before discount' : 'Total annual premium'}`, value: Helpers.toCurrency(annualPremium), type: 'total', hasDiscount },
        hasDiscount && {
          text: 'Total annual premium after discount', value: totalPremium,
          promotions: promotions.filter(o => o)
        },
      ].filter(o => !isEmpty(o) && !isNil(o)),
      breakdown: [
        { text: `Premium breakdown`, value: ''}
      ],
      firstYearDiscountEligible: this.firstYearDiscountEligible,
      perpetualDiscountEligible: this.perpetualDiscountEligible,
      totalPerpetualDiscount: `${this.totalPerpetualDiscount}%`,
      totalFirstYearDiscount: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType)
    }
  }

  public get sioPremium() {
    const coverages = [...this.coverages];
    const coverage: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const premiumTerm = Helpers.getPremiumTermByCode(get(coverage, 'attributes.planPremiumMode', '-'));
    const discountEligible = get(coverage, `attributes.discountEligible`, false)
    const annualPremium = this.totalOriginalPremiumAmt || 0;
    const firsYearDiscountType = get(coverage, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(coverage, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    const promotions: any[] = [];
    if (discountEligible) {
      promotions.push(
        this.perpetualDiscountEligible && { text: 'Perpetual discount', value: `${this.totalPerpetualDiscount}%` },
        this.firstYearDiscountEligible && { text: 'First year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType) },
      )
    }
    const discountedAnnualPremium = discountEligible ? this.totalAftDisOriginalPremiumAmt || 0 : annualPremium || 0;

    const hasDiscount = this.firstYearDiscountEligible || this.perpetualDiscountEligible;

    return {
      totalAnnualizedPremium: this.totalAnnualizedPremium,
      totalPremium: { text: `premium payable`, value: Helpers.toCurrency(discountedAnnualPremium) },
      details: [
        { text: `${hasDiscount ? 'Premium before discount' : 'Premium payable'}`, value: Helpers.toCurrency(annualPremium), type: 'total', hasDiscount },
        hasDiscount && {
          text: 'Premium payable after discount', value: Helpers.toCurrency(discountedAnnualPremium),
          promotions: promotions.filter(o => o)
        },
      ].filter(o => !isEmpty(o) && !isNil(o)),
      paymentFrequency: { text: 'Payment frequency', value: premiumTerm }
    };
  }

  public get dpiPremium() {
    const coverage = this.coverages[0] || null;
    const premiumTerm = Helpers.getPremiumTermByCode(get(coverage, 'attributes.planPremiumMode', '-'));
    return {
      totalPremium: { text: `premium payable`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0) },
      details: [
        { text: `Premium payable`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0), type: 'total', hasDiscount: false },
      ],
      paymentFrequency: { text: 'Payment frequency', value: premiumTerm }
    };
  }

  public get sioPlanDetails() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const planPremiumMode = get(simplePlan, 'attributes.planPremiumMode', '');
    const premiumFreq = Helpers.getPremiumTermByCode(planPremiumMode);
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    if (simplePlan) {
      const simplePlanDetails = this.getPlanDetails(simplePlan);
      listing.push(
        { text: 'Basic plan', value: get(simplePlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(simplePlanDetails, 'sumAssured', '-') },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(simplePlanDetails, 'discPremiumAmount', '-') },
      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push(
        { text: 'Rider', value: get(ciPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
      )
    }

    if (personalAccidentPlan) {
      const paPlanDetails = this.getPlanDetails(personalAccidentPlan);
      listing.push(
        { text: 'Rider', value: get(paPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: Helpers.toCurrency(get(paPlanDetails, 'sumAssured', '-')) },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(paPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    const firsYearDiscountType = get(simplePlan, 'attributes.discountedPremium.firstYrDiscType', '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(simplePlan, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    listing.push(
      { text: 'Premium payment frequency', value: premiumFreq, reviewOnly: true },
      { text: `Total ${toLower(premiumFreq)} premium`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0), reviewOnly: true },
      (this.firstYearDiscountEligible || this.perpetualDiscountEligible) && { text: `Total ${toLower(premiumFreq)} premium payable (after discount applied)`, value: Helpers.toCurrency(this.totalAftDisOriginalPremiumAmt || 0), reviewOnly: true },
      this.perpetualDiscountEligible && { text: 'Perpetual discount', value: this.totalPerpetualDiscount + '%', reviewOnly: true },
      this.firstYearDiscountEligible && { text: 'First year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType), reviewOnly: true },
    )
    return listing.filter(o => !isEmpty(o) && !isNil(o));
  }

  public get dpiPlanDetails() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    const premiumFrequency = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));
    const premiumFreq = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));

    if (directTermPlan) {
      const directPlanDetails = this.getPlanDetails(directTermPlan);
      listing.push(
        { text: 'Basic plan', value: get(directPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(directPlanDetails, 'sumAssured', '-') },
        { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
        { text: 'Premium amount', value: get(directPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push(
        { text: 'Add-on coverage', value: get(ciPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
        { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
        { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    listing.push(
      { text: 'Premium payment frequency', value: premiumFrequency },
      { text: `Total ${toLower(premiumFreq)}  premium`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0) },
      { text: '* Premium payment term is equal to the policy term', value: '', reviewOnly: true }
    )
    return listing;
  }

  public get dpiPremiumTerm(): string {
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    return `${premiumTerm} years`;
  }

  public get sioPlanDetailsSummary() {
    const summaries = this.sioPlanDetails;
    const totalPremium = this.discountEligible ? this.totalAftDisOriginalPremiumAmt : this.totalOriginalPremiumAmt;
    return [
      ...summaries.filter(o => !get(o, 'reviewOnly', false)),
      { text: `Total premium amount`, value: Helpers.toCurrency(totalPremium || 0), fontWeight: 'bold' }
    ]
  }

  public get promoCode() {
    const coverage = this.coverages[0] || null;
    console.log("get promocode",coverage);
    return get(coverage, 'attributes.discountedPremium.promoCode', '');
  }

  public get sumAssured() {
    const coverage = this.coverages[0] || null;
    return get(coverage, 'attributes.sumAssured', 0);
  }

  public get discounts(): any {
    const list = [];
    const coverage = this.coverages[0] || null;
    const discountEligible = get(coverage, `attributes.discountEligible`, false);
    if (discountEligible) {
      list.push(
        this.perpetualDiscountEligible && `The ${this.totalPerpetualDiscount}% discount is applied annually on policy renewal.`,
        this.firstYearDiscountEligible && `1st year discount is a one-time discount on premiums in the first policy year and does not apply on policy renewal.`
      )
    }
    return list.filter(o => !isEmpty(o));
  }

  public get sioAddon(): { name: string, price: string }[] {
    let list: { name: string, price: string }[] = [];
    const coverages = [...this.coverages];
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    if (illnessCoverPlan) {
      list.push({ name: illnessCoverPlan.name || '', price: `${illnessCoverPlan.attributes?.sumAssured || 0}` })
    }
    if (personalAccidentPlan) {
      list.push({ name: personalAccidentPlan.name || '', price: `${personalAccidentPlan.attributes?.sumAssured || 0}` })
    }
    return list;
  }

  
  public get dpiAddon(): { name: string, price: string }[] {
    let list: { name: string, price: string }[] = [];
    const coverages = [...this.coverages];
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    if (illnessCoverPlan) {
      list.push({ name: illnessCoverPlan.name || '', price: `${illnessCoverPlan.attributes?.sumAssured || 0}` })
    }
    return list;
  } 

  public checkValidPromoCode(inputCode: string): { valid: boolean, error: string } {
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { type: 'P' });
    const discountEligible = simplePlan?.attributes?.discountEligible;
    const promoCode = get(simplePlan, 'attributes.promoCode', '');
    if (inputCode === promoCode && discountEligible) {
      return { valid: true, error: '' };
    }
    // return { valid: true, error: '' }; //use for local check bypass
    return {
      valid: false,
      error: 'Promo code is invalid'
    };
  }

  private formatDiscount(value: number, type: string): string {
    if (type === 'dollar') {
      return Helpers.toCurrency(value);
    }
    if (type === 'percent' || type === 'P') {
      return `${value}%`
    }
    return `${Helpers.toCurrency(value)}`;
  }


  /**Cleaning code */

  private getPlanDetails(plan: Coverages): any {
    if (isNil(plan) || isEmpty(plan)) {
      return null;
    }

    const premiumAmount = get(plan, `attributes.modalPremium`, '-');
    let finalPremiumAmount = premiumAmount;
    const name = get(plan, 'name', '-');
    const sumAssured = get(plan, 'attributes.sumAssured', '-');

    const isDiscountEligible = get(plan, 'attributes.discountEligible', false);
    const isFirstYearDiscount = get(plan, 'attributes.firstYrDiscountEligible', false);

    const hasFirstYrDiscount = isDiscountEligible &&
      isFirstYearDiscount &&
      get(plan, 'attributes.discountedPremium.firstYrDiscAmnt', 0) > 0

    const hasPerpectualDiscount = isDiscountEligible &&
      get(plan, 'attributes.discountedPremium.staffDiscount', 0) > 0


    if (hasFirstYrDiscount) {
      finalPremiumAmount = get(plan, `attributes.discountedPremium.firstYrModalPremium`, '-')
    } else {
      if (hasPerpectualDiscount) {
        finalPremiumAmount = get(plan, `attributes.discountedPremium.modalPremium`, '-')
      }
    }

    return {
      name,
      sumAssured: Helpers.toCurrency(sumAssured),
      premiumAmount: Helpers.toCurrency(premiumAmount),
      discPremiumAmount: Helpers.toCurrency(finalPremiumAmount),
    }

  }
}